module.exports = __webpack_public_path__ + "f61a4eb27371b7453bf5b12ab3648b9e.ttf";